import { theme } from '@l_ine/core';

const themeDefault = theme.createTheme({});

export default themeDefault;
